import styled from 'styled-components';

var TreeNodeDropRegion = styled.div.withConfig({
  displayName: "NodeDropRegion__TreeNodeDropRegion",
  componentId: "sc-15hkr7j-0"
})(["&&{position:absolute;height:calc(100% - 20px);top:10px;left:24px;width:calc(100% - 24px);z-index:3;}"]);

export { TreeNodeDropRegion };
